<template>
  <section class="contact_form_area contact_us section_padding">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <div class="contact-right contact_details">
            <div class="hero-title-with-shape">
              <h4 class="heading_with_border">Connect with us</h4>
              <h1>We offer 24/7 emergency service to all of our customers!</h1>
            </div><!--end .hero-title-with-shape-->
            <p>Contact us for any of your water, gas, or sewer installation or repair needs.</p>
            <div class="contact_location_box">
              <div class="contact_location_map">
                <span class="icon-location"></span>
                <p>1612 Runnymeade Ave <br>Decatur AL</p>
              </div><!--end .contact_location_map-->
              <div class="contact_location_map contact_location_call">
                <span class="icon-contact_call"></span>
                <p>bobby.vest@vestplumbing.com <br>256 214 1556</p>
              </div><!--end .contact_location_map .contact_location_call-->
            </div><!--end .contact_location_box-->
          </div><!--end .contact-right .contact_details-->
        </div><!--end .col-md-6-->
        <div class="col-md-6">
          <div class="contact-right contact-right-style-2 responsive_mt">
            <form method="post" @submit.prevent="sendEmail">
              <input v-model="form.name" class="half_width input_m_right" type="text" name="name" placeholder="Your name">
              <input v-model="form.email" class="half_width" type="EMAIL" name="email" placeholder="Email address">
              <input v-model="form.tel" type="tel" name="tel" placeholder="Phone number">
              <textarea v-model="form.content"  name="content" id="content" cols="20" rows="5" placeholder="Write message"></textarea>
             <div class="row">
					<div class="col-md-3"><button class="btn-yellow" value="SUBMIT NOW">SUBMIT NOW</button></div>
					<div class="col-md-3"><h4>{{submitMessage}}</h4></div>
			</div>
			 </form>
			<FlashMessage />
          </div><!--end .contact-right .contact-right-style-2-->
        </div><!--end .col-md-6-->
      </div><!--end .row-->
    </div><!--end .container-->
  </section>
</template>

<script>
	import axios from 'axios';
	
	export default {
		 name: "Contact",
		  
		 data() {
			return {
				form: {  
					name: '',
				    email: '',
					tel: '',
					content: '',
				},
				submitMessage: '',
			};
		  },
		 methods: {
			clearForm: function() {
				this.form.name =  '';
				this.form.email =  '';
				this.form.tel =  '';
				this.form.content = '';
			},
			sendEmail: async function() {
				var params = {};
				const vm = this;
				
				//formData.forEach((value, key) => params[key] = value);
				for (const [key, value] of Object.entries(this.form)) {
					params[key] = value;
				}
				
				await axios.post('https://vestplumbing.com/php/mail.php', params, 
				{
					headers: {
						'content-type': 'application/json'
					}
				})
				
				.then(function(response) {
					vm.clearForm();
					vm.submitMessage = "The form was submitted!";
					/*this.flashMessage.success({
                            title: 'Message',
                            message: 'Message Sent',
                            time: 5000,
                            flashMessageStyle: {
                                backgroundColor: 'linear-gradient(#e66465, #9198e5)'
                            }
                        });*/
				})
				.catch((e) => {
					//window.location.href = "#";
					vm.clearForm();
					vm.submitMessage = "The message was sent!";
					console.log(e);
				});
			},
		}
    }
	
	
	
</script>

<style scoped>

</style>
